import { BaseRollerProductType } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isRollerSingle = ({ products }: ProductBuilderMachineContext) => {
  const rollerDayNightChainlessBaseProductType: BaseRollerProductType =
    'Roller Blind Single Chainless';
  const rollerDayNightChainBaseProductType: BaseRollerProductType =
    'Roller Blind Single Chain';
  const location = window.location.pathname.includes('roller-single');
  return (
    (products[0].type.includes(rollerDayNightChainlessBaseProductType) &&
      location) ||
    (products[0].type.includes(rollerDayNightChainBaseProductType) && location)
  );
};
